exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td.col-error{background:rgba(213,0,0,.1)}.dark td.col-error{background:rgba(239,83,80,.1)}td.col-uploading .form-element-edit{display:none}td .upload-overlay{display:flex;align-items:center;justify-content:center;position:absolute;height:100%;width:100%;background:hsla(0,0%,92%,.75);pointer-events:none;z-index:1}.dark td .upload-overlay{background:rgba(66,66,66,.75)}", ""]);

// exports
